export default __webpack_public_path__ + "static/media/m_welcome_bg.6b1c0d69.png";